import { SignupActionTypes, AccountType, SignupState } from './signup.types';

export const CREATE_ACCOUNT: SignupActionTypes = 'CREATE_ACCOUNT';
export const REGISTER_OR_UPDATE_BUSINESS: SignupActionTypes = 'REGISTER_OR_UPDATE_BUSINESS';
export const VALIDATE_EMAIL: SignupActionTypes = 'VALIDATE_EMAIL';

export const CLIENT: AccountType = 'CLIENT';
export const ADMIN: AccountType = 'ADMIN';

export const initialSignupState: SignupState = {
  statusCode: 0,
  account: {
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    accountType: 'CLIENT',
    cancelled: true,
    authorities: []
  },
  validation: {}
};



// WEBPACK FOOTER //
// ./src/admin/signup.constants.tsx